<template>
  <div
    v-if="hasAnyValue"
    class="margin-cell"
  >
    <template v-if="hasRanges">
      <v-tooltip top>
        <template #activator="{ on, attrs }">
          <span
            class="margin-cell__value margin-cell__value--with-ranges"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon small>mdi-layers-outline</v-icon>
            {{ formatPercent(marginDesired) }}
          </span>
        </template>
        <div class="margin-cell__ranges">
          <div class="margin-cell__range-row">
            <span class="margin-cell__range-min">≥ 0</span>
            <span class="margin-cell__range-rate">{{ formatPercent(marginDesired) }}</span>
          </div>
          <div
            v-for="(tier, index) in sortedRanges"
            :key="`margin-tier-${index}`"
            class="margin-cell__range-row"
          >
            <span class="margin-cell__range-min">
              ≥ {{ formatAmount(tier.minAmount, 2) }}
            </span>
            <span class="margin-cell__range-rate">
              {{ formatPercent(tier.marginPercent) }}
            </span>
          </div>
        </div>
      </v-tooltip>
    </template>
    <span
      v-else
      class="margin-cell__value"
    >
      {{ formatPercent(marginDesired) }}
    </span>
  </div>
</template>

<script>
export default {
  name: "MarginCell",
  props: {
    marginDesired: {
      type: [String, Number],
      default: ''
    },
    marginDesiredRanges: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    hasRanges() {
      return Array.isArray(this.marginDesiredRanges) && this.marginDesiredRanges.length > 0;
    },
    sortedRanges() {
      if (!this.hasRanges) {
        return [];
      }
      return [...this.marginDesiredRanges].sort((a, b) => {
        const aMin = Number(a?.minAmount ?? 0);
        const bMin = Number(b?.minAmount ?? 0);
        return aMin - bMin;
      });
    },
    hasAnyValue() {
      return (
        this.hasRanges ||
        (this.marginDesired !== null && this.marginDesired !== undefined && this.marginDesired !== '')
      );
    }
  },

  methods: {
    formatPercent(value) {
      if (value === null || value === undefined || value === '') {
        return '—';
      }
      return `${value} %`;
    },
    formatAmount(value, digits = 2) {
      if (value === null || value === undefined || value === '') {
        return '—';
      }
      const formatter = this.$options?.filters?.formatMoney;
      return formatter ? formatter(value, digits) : value;
    }
  }
};
</script>

<style lang="scss" scoped>
.margin-cell {
  display: inline-flex;
  align-items: center;
  gap: 4px;

  &__value {
    display: inline-flex;
    align-items: center;
  }

  &__value--with-ranges {
    color: #1976d2;
    font-weight: 600;
    cursor: pointer;

    .v-icon {
      font-size: 16px;
      margin-right: 4px;
    }
  }

  &__ranges {
    min-width: 200px;
    display: flex;
    flex-direction: column;
  }

  &__range-row {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    padding: 2px 0;
  }

  &__range-min {
    font-weight: 600;
    padding-right: 8px;
  }
}
</style>
